<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'processingPurposeSummary.cardTitle' | t }}</div>
    @if (summaryModel) {
        <div class="detail-page-card-actions">
            @if (summaryModel.CanOpenParent) {
                <button class="btn btn-raised" (click)="openProcessingPurpose()">
                    <i class="fas fa-external-link-alt"></i>
                    <span>{{ 'processingPurposeSummary.openDataProcessingBtn' | t }}</span>
                </button>
            }
        </div>
    }

    <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
        @if (summaryModel) {
            <div>
                <div class="row">
                    <div class="col-6">
                        <div class="row">
                            <div class="col-3">
                                <div class="form-group">
                                    <label>{{ 'processingPurposeSummary.identifierLabel' | t }}</label>
                                    <input
                                        data-uiid="dm-moi-identifier"
                                        type="text"
                                        class="form-control form-control-sm"
                                        disabled
                                        [value]="summaryModel.Identifier"
                                        inputTooltip
                                    />
                                </div>
                            </div>
                            <div class="col-9">
                                <div class="form-group">
                                    <label>{{ 'processingPurposeSummary.nameDataProcessingLabel' | t }}</label>
                                    <input
                                        data-uiid="dm-moi-name"
                                        type="text"
                                        class="form-control form-control-sm"
                                        disabled
                                        [value]="summaryModel.Name"
                                        inputTooltip
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label>{{ 'processingPurposeSummary.dataSubjectsLabel' | t }}</label>
                                    <input
                                        data-uiid="dm-moi-datasubjects"
                                        type="text"
                                        class="form-control form-control-sm"
                                        disabled
                                        [value]="summaryModel.DataSubject"
                                        inputTooltip
                                    />
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label>{{ 'processingPurposeSummary.mostRecentDpiaLabel' | t }}</label>
                                    <date-input
                                        data-uiid="dm-moi-mostrecentdpia"
                                        [(value)]="summaryModel.LatestDpia"
                                        [disabled]="true"
                                    ></date-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label>{{ 'processingPurposeSummary.descriptionLabel' | t }}</label>
                            <textarea
                                data-uiid="dm-moi-description"
                                class="form-control form-control-sm"
                                disabled
                                [value]="summaryModel.Description"
                                inputTooltip
                            ></textarea>
                        </div>
                    </div>
                </div>
            </div>
        } @else {
            <div class="fancy-loader submodule my-4"></div>
        }
    </div>
</div>
